import axios from "../util/axios";
import { convertToUTCDayBoundary } from "../util/date";
export const getDonations = async (
  currentPage,
  search = "",
  paymentStatus = null,
  dateFrom = null,
  dateTo = null,
  amountMin = null,
  amountMax = null
) => {
  try {
    const perPageContent = 10;
    const offset = (+currentPage - 1) * +perPageContent;
    const params = {
      offset,
      limit: perPageContent,
      sort: JSON.stringify([["created_at", "desc"]]),
    };
    const whereCondition = {};

    if (search !== "") {
      params.search = search;
    }

    if (paymentStatus !== null && paymentStatus !== "") {
      whereCondition.payment_status = paymentStatus;
    }

    if (dateFrom) {
      const _date = convertToUTCDayBoundary(
        dateFrom,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        "start"
      );
      whereCondition.created_at = {
        ...whereCondition.created_at,
        $gte: _date.toISOString(),
      };
    }

    if (dateTo) {
      const _date = convertToUTCDayBoundary(
        dateTo,
        Intl.DateTimeFormat().resolvedOptions().timeZone,
        "end"
      );
      whereCondition.created_at = {
        ...whereCondition.created_at,
        $lte: _date.toISOString(),
      };
    }

    if (Object.keys(whereCondition).length > 0) {
      params.where = JSON.stringify(whereCondition);
    }

    const response = await axios.get("/donation", { params });
    return response?.data?.data;
  } catch (error) {
    throw new Error(error?.response?.data?.error || "Something went wrong");
  }
};

export const getDonation = async (id) => {
  try {
    const response = await axios.get(`/donation/${id}`);
    return response?.data?.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      throw new Error("404");
    } else {
      throw new Error(error?.response?.data?.error || "Something went wrong");
    }
  }
};
